enum MessageTypes {
    GET_ACCESS_TOKEN = "getAccessToken",
    SET_ACTION_TOKEN = "setActionToken",
    CLOSING = "closing"
}

export default MessageTypes